import React, { useState, useEffect } from "react";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "../../styles/style.css";
import "../../styles/payout.css";
import "../../styles/upi-mandate.css";
import trashIcon from "../../assets/images/trash-03.svg";
import editIcon from "../../assets/images/edit-02.svg";
import { Button, Modal, Offcanvas } from "react-bootstrap";
import plusWhite from "../../assets/images/plus-white.svg";
import { useFormik } from "formik";
import ThumbnailPicker from "../../components/ThumbnailPicker/ThumbnailPicker";
import uploadImage from "../../action/imageUpload";
import { AddGovtScheme, deleteScheme, fetchGovtScheme, updateGovtScheme } from "../../action/govtScheme";
import { Loader } from "../../components/loader";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import Pagination from "../../components/pagination/paginationView";
import showNotification from "../../components/notification/showNotification";


const GovtScheme = () => {
    const [list, setList] = useState([]);
    const [deleteId, setDeleteId] = useState("");
    const [updateId, setUpdateId] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationValue, setPaginationValue] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [isOpenmodel, setIsOpenmodel] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isOpenEditModal, setIsOpenEditModal] = useState(false);
    const handleDeleteScheme = async (id) => {
        setIsLoading(true);
        const response = await deleteScheme(id);
        if (response.status) {
            setIsOpenmodel(false);
            getGovtScheme();
            showNotification(
                "Govt. Scheme",
                "Scheme Deleted Successfully!",
                "success"
            );
        }
    };

    const getGovtScheme = async () => {
        setIsLoading(true);
        const response = await fetchGovtScheme(currentPage, paginationValue);
        if (response.status) {
            setList(response.data.list);
            setTotalRecords(response.data.count);
            setIsLoading(false);
            console.log("response", response.data.list)
            console.log("responseCount", response.data.count)
        }
    };
    const addFormik = useFormik({
        initialValues: {
            title: "",
            desc: "",
            assets: {
                url: "",
                type: 2,
                h: 200,
                w: 200,

            }
        },
        onSubmit: async (values) => {
            console.log('values', values);
            const response = await AddGovtScheme(values);
            console.log('values', values);
            if (response?.status) {
                getGovtScheme();
                setIsOpenModal(false);
                showNotification(
                    "Govt. Scheme",
                    response.data?.message,
                    "success"
                );
                addFormik.resetForm();
            } else {
                showNotification(
                    "Eror!",
                    "Please upload Scheme image",
                    "danger"
                );
            }
        },
    });
    const EditFormik = useFormik({
        initialValues: {
            title: "",
            desc: "",
            assets: {
                url: "",
                type: 2,
                h: 200,
                w: 200,

            }
        },
        onSubmit: async (values) => {
            const response = await updateGovtScheme(updateId, values);
            if (response?.status) {
                showNotification(
                    "Govt.Scheme",
                    "Scheme Edit Successfully",
                    "success"
                );
                setIsOpenEditModal(false);
                // refresh the banner list after adding
                EditFormik.resetForm();
                getGovtScheme();
            } else {
                showNotification(
                    "Error!",
                    "Please upload  scheme image",
                    "danger"
                );
            }
        },
    });
    console.log('EditFormik', EditFormik.values);
    useEffect(() => {
        getGovtScheme();
    }, [currentPage, paginationValue]);
    const uploadMediaImage = async (file, type) => {
        if (file.type.startsWith("image/")) {
            const formData = new FormData();
            formData.append("file", file);
            const res = await uploadImage(formData, "gaon");
            if (res.status) {
                if (type == 1) {
                    if (isOpenModal) {
                        addFormik.setFieldValue("assets.url", res.data[0]);
                    }
                    if (isOpenEditModal) {
                        EditFormik.setFieldValue("assets.url", res.data[0]);
                    }
                } else {
                    if (isOpenModal) {
                        addFormik.setFieldValue("assets.url", res.data[0]);
                    }
                    if (isOpenEditModal) {
                        EditFormik.setFieldValue("assets.url", res.data[0]);
                    }
                }
            }
        } else {
            showNotification(
                "Error!",
                "You can upload only image",
                "danger"
            );
        }
    };
    useEffect(() => {
        getGovtScheme();
    }, [currentPage, paginationValue]);
    return (
        <div className="payout_data-content">
            <div className="payout_inner_content">
                <div className="payout_data-head">
                    <div className="payout_data-head-top">
                        <div className="payout_data-left p-0">
                            <div className="payout_data_ttl">
                                <Breadcrumb
                                    paths={[
                                        // {
                                        //     name: `Dashboard`,
                                        //     link: `/`,
                                        // },
                                        {
                                            name: "Govt. Scheme",
                                            link: `/user-notification`,
                                        },
                                    ]}
                                />
                            </div>
                        </div>
                        <Button
                            color="info"
                            tag="a"
                            type="button"
                            onClick={() => {
                                setIsOpenModal(true);
                            }}
                        >
                            Add New Scheme
                            <img src={plusWhite} alt="" className="payout_down" />
                        </Button>
                    </div>
                </div>
                <table className="payout_table upi-mandate_table">
                    <tr className="tableHead">
                        <th className="thHeader">
                            <div className="payoutHead hndIcon">Title</div>
                        </th>
                        <th className="thHeader">
                            <div className="payoutHead hndIcon">Description</div>
                        </th>
                        <th className="thHeader">
                            <div className="payoutHead hndIcon">Image</div>
                        </th>
                        <th className="thHeader">
                            <div className="payoutHead headerAction">Action </div>
                        </th>
                    </tr>
                    {isLoading ? (
                        <tr>
                            <td colSpan="9">
                                <Loader />
                            </td>
                        </tr>
                    ) : (
                        <>
                            {list.length > 0 ? (
                                list.map((item) => {
                                    return (
                                        <tr>
                                            <td>{item?.title}</td>
                                            <td>{item?.desc}</td>
                                            <td><img src={`${process.env.REACT_APP_S3_URL}/${item?.assets?.url}`} style={{ height: "70px" }} alt="data" /></td>
                                            <td>
                                                <div className="flex_btn justify-content-center">
                                                    <button className="action_btn1" onClick={() => {
                                                        setIsOpenmodel(true);
                                                        setDeleteId(item._id);
                                                    }

                                                    }>
                                                        <img src={trashIcon} alt="Delete" className="pointer" />
                                                    </button>

                                                    <button className="action_btn1" onClick={() => {
                                                        setIsOpenEditModal(true);
                                                        setUpdateId(item._id);
                                                        EditFormik.setFieldValue("title", item?.title)
                                                        EditFormik.setFieldValue("desc", item?.desc)
                                                        EditFormik.setFieldValue("assets.url", item?.assets?.url)


                                                    }
                                                    }><img src={editIcon} alt="Edit icon" className="pointer" /></button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <>
                                    <tr>
                                        <td colSpan="9" className="text_center">
                                            No data available
                                        </td>
                                    </tr>
                                </>
                            )}
                        </>
                    )}
                </table>{" "}

            </div>

            <Pagination
                currentPage={currentPage}
                totalCount={totalRecords}
                pageSize={paginationValue}
                onPageChange={(page) => setCurrentPage(page)}
                changePageSize={(page) => {
                    setPaginationValue(page);
                    setCurrentPage(1);
                }}
            />

            <Offcanvas
                show={isOpenModal}
                onHide={() => {
                    setIsOpenModal(false);
                    addFormik.handleReset();
                }}
                placement="end"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add Govt. Scheme</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="add_buyer_content">
                        <form onSubmit={addFormik.handleSubmit}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="input-box">
                                        <div className="input-label">Title</div>
                                        <div className="input_field">
                                            <input
                                                className="input"
                                                required
                                                name="title"
                                                placeholder="Enter Title"
                                                value={addFormik.values.title}
                                                onChange={addFormik.handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="input-box">
                                        <div className="input-label">Description</div>
                                        <div className="input_field">
                                            <input
                                                className="input"
                                                required
                                                name="desc"
                                                placeholder="Enter Description"
                                                value={addFormik.values.desc}
                                                onChange={addFormik.handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="option-card"
                                    style={{ display: "flex", marginTop: "36px" }}
                                >
                                    <ThumbnailPicker
                                        width="60%"
                                        height="250px"
                                        onFileSelect={(file) => {
                                            const _URL = window.URL || window.webkitURL;

                                            const img = new Image();
                                            uploadMediaImage(file, 1);

                                            img.src = _URL.createObjectURL(file);
                                        }}
                                        image={addFormik.values?.assets?.url}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="mt-3 flex_btn">
                                <button className="btn btn-success" type="submit">
                                    Create
                                </button>
                            </div>
                        </form>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            <Offcanvas
                show={isOpenEditModal}
                onHide={() => {
                    setIsOpenEditModal(false);
                    EditFormik.handleReset();
                }}
                placement="end"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Update Govt. Scheme</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="add_buyer_content">
                        <form onSubmit={EditFormik.handleSubmit}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="input-box">
                                        <div className="input-label">Title</div>
                                        <div className="input_field">
                                            <input
                                                className="input"
                                                required
                                                name="title"
                                                placeholder="Enter Title"
                                                value={EditFormik.values.title}
                                                onChange={EditFormik.handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="input-box">
                                        <div className="input-label">Description</div>
                                        <div className="input_field">
                                            <input
                                                className="input"
                                                required
                                                name="desc"
                                                placeholder="Enter Description"
                                                value={EditFormik.values.desc}
                                                onChange={EditFormik.handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="option-card"
                                    style={{ display: "flex", marginTop: "36px" }}
                                >
                                    <ThumbnailPicker
                                        width="60%"
                                        height="250px"
                                        onFileSelect={(file) => {
                                            const _URL = window.URL || window.webkitURL;

                                            const img = new Image();
                                            uploadMediaImage(file, 1);

                                            img.src = _URL.createObjectURL(file);
                                        }}
                                        image={EditFormik.values?.assets?.url}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="mt-3 flex_btn">
                                <button className="btn btn-success" type="submit">
                                    Update Scheme
                                </button>
                            </div>
                        </form>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            <Modal
                show={isOpenmodel}
                onHide={() => setIsOpenmodel(false)}
            >
                <Modal.Header>
                    <Modal.Title>Delete Scheme</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        Are you sure you want to delete scheme
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="btn-dark"
                        variant="secondary"
                        onClick={() => (setIsOpenmodel(false))}
                    >
                        Cancel
                    </Button>
                    <Button
                        className=" btn-success"
                        variant="primary"
                        onClick={() => {
                            handleDeleteScheme(deleteId)
                        }}
                    >
                        delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div >
    );
};


export default GovtScheme